<div class="dashboard-wrapper">
  <!-- 1. TOP HEADER -->
  <header class="top-header">
    <div class="header-content">
      <div class="header-left">
        <img src="assets/odisha-logo.png" alt="Government of Odisha" class="gov-logo">
        <div class="logo-box">D</div>
        <div class="title-block">
          <h1>Dhamnagar D3</h1>
          <p>CONSTITUENCY MANAGEMENT</p>
        </div>
      </div>

      <div class="header-right" *ngIf="isAuthenticated()">
        <div class="user-profile">
          <div class="avatar-wrap">
            @if (profileUi.avatarUrl(currentUser()); as src) {
              <img [src]="src" alt="Profile">
            } @else {
              <div class="avatar-initial">{{ profileUi.avatarInitial(currentUser()) }}</div>
            }
          </div>
          <div class="profile-info">
            <span class="user-name">{{ profileUi.displayName(currentUser()) }}</span>
            <span class="user-title">{{ profileUi.designation(currentUser()) }}</span>
            <span class="user-role">{{ profileUi.roleBadge(currentUser()) }} <i class="fa-solid fa-chevron-down"></i></span>
          </div>
          <button class="logout-box" (click)="showLogoutModal.set(true)" title="Logout">
            <i class="fa-solid fa-right-from-bracket"></i>
          </button>
        </div>
      </div>
    </div>
  </header>

  <!-- BACKGROUND MAP (FADED) -->
  <div class="background-map-overlay"></div>

  <main class="main-container">
    <!-- ── LIVE MONITORING RIBBON ─────────────────────────────────────── -->
    <section class="monitor-ribbon" role="region" aria-label="Live monitoring summary">

      <!-- HM PENDING -->
      <button class="mr-card mr-orange mr-mob-order-2" (click)="openHmList('hmPending')"
              [class.has-alert]="hmStats$.hmPendingCount() > 0"
              type="button"
              aria-label="HM pending projects">
        <div class="mr-icon"><i class="fa-solid fa-user"></i></div>
        <div class="mr-body">
          <div class="mr-row">
            <span class="mr-num">{{ hmStats$.hmPendingCount() }}</span>
            <span class="mr-tag mr-tag-full">HM Pending</span>
            <span class="mr-tag mr-tag-short">HM Pending</span>
          </div>
          <span class="mr-sub">Awaiting OSD Approval</span>
        </div>
      </button>

      <span class="mr-sep"></span>

      <!-- LOW PROGRESS -->
      <button class="mr-card mr-amber mr-mob-order-3" (click)="openHmList('lowProgress')"
              [class.has-alert]="hmStats$.lowProgressCount() > 0"
              type="button"
              aria-label="Low progress projects">
        <div class="mr-icon"><i class="fa-solid fa-chart-line"></i></div>
        <div class="mr-body">
          <div class="mr-row">
            <span class="mr-num">{{ hmStats$.lowProgressCount() | number }}</span>
            <span class="mr-tag mr-tag-full">Low Progress &lt;30%</span>
            <span class="mr-tag mr-tag-short">Low Progress</span>
          </div>
          <span class="mr-sub">Needs Immediate Monitoring</span>
        </div>
      </button>

      <span class="mr-sep"></span>

      <!-- DELAYED -->
      <button class="mr-card mr-red mr-mob-order-1" (click)="openHmList('hmDelayed')"
              [class.has-alert]="hmStats$.delayedCount() > 0"
              [class.pulse]="hmStats$.delayedCount() > 0"
              type="button"
              aria-label="Delayed projects">
        <div class="mr-icon"><i class="fa-solid fa-triangle-exclamation"></i></div>
        <div class="mr-body">
          <div class="mr-row">
            <span class="mr-num">{{ hmStats$.delayedCount() }}</span>
            <span class="mr-tag mr-tag-full">Delayed Projects</span>
            <span class="mr-tag mr-tag-short">Delayed</span>
          </div>
          <span class="mr-sub">Critical Intervention Required</span>
        </div>
      </button>

      <span class="mr-sep"></span>

      <!-- SYSTEM STATUS -->
      <div class="mr-card mr-green mr-status mr-mob-order-4"
           [class.offline]="hmStats$.systemHealth().status === 'offline'"
           role="status"
           aria-live="polite">
        <div class="mr-icon">
          <span class="mr-live-dot" [class.live]="hmStats$.isLive()"></span>
        </div>
        <div class="mr-body">
          <div class="mr-row">
            <span class="mr-tag mr-status-label mr-tag-full">
              {{ hmStats$.systemHealth().status === 'active' ? 'System Active' :
                 hmStats$.systemHealth().status === 'idle'   ? 'No Data Yet'   : 'Offline' }}
            </span>
            <span class="mr-tag mr-status-label mr-tag-short">
              {{ hmStats$.systemHealth().status === 'active' ? 'Active' :
                 hmStats$.systemHealth().status === 'idle'   ? 'Idle'     : 'Offline' }}
            </span>
          </div>
          <span class="mr-sub">
            <i class="fa-regular fa-clock"></i>
            Live · Synced {{ hmStats$.lastSync() | date:'shortTime' }}
          </span>
        </div>
      </div>
    </section>

    <!-- 3. CENTER HERO SECTION -->
    <section class="hero-section">
      <h2 class="hero-title">Project & Programme Management System</h2>
      <p class="hero-subtitle">Dhamnagar Assembly Constituency</p>
      
      <div class="hero-features">
        <span>Live Monitoring</span>
        <span class="dot">•</span>
        <span>Department Tracking</span>
        <span class="dot">•</span>
        <span>Intervention Control</span>
      </div>
      <div class="orange-divider"></div>
    </section>

    <!-- MOBILE SECTION LABEL: Quick Actions -->
    <h3 class="mob-section-label">Quick Actions</h3>

    <!-- 5. MAIN DASHBOARD MODULE CARDS -->
    <section class="module-cards-grid">
      <!-- LEFT CARD: HM Decision Dashboard -->
      <div class="module-card blue-theme" (click)="navigateToDashboard()">
        <div class="primary-badge">PRIMARY</div>
        <div class="card-header">
          <div class="card-icon-square bg-blue">
            <i class="fa-solid fa-chart-line"></i>
          </div>
          <div class="card-header-text">
            <h3 class="card-title">HM Decision Dashboard</h3>
            <p class="card-desc-short">Global analytics, department tracking, and performance reports.</p>
          </div>
        </div>
        
        <div class="feature-icons-grid">
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-bell"></i></div>
            <span>Alerts & Interventions</span>
          </div>
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-users-gear"></i></div>
            <span>Department Overview</span>
          </div>
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-rectangle-list"></i></div>
            <span>HM Projects Tracking</span>
          </div>
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-chart-column"></i></div>
            <span>Reports & Analytics</span>
          </div>
        </div>

        <button class="card-action-btn">
          View Dashboard <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>

      <!-- RIGHT CARD: Field Execution -->
      <div class="module-card orange-theme" (click)="navigateToFieldExecution()">
        <div class="card-header">
          <div class="card-icon-square bg-orange">
            <i class="fa-solid fa-helmet-safety"></i>
          </div>
          <div class="card-header-text">
            <h3 class="card-title">Field Execution</h3>
            <p class="card-desc-short">Manage blocks, GPs, and ground-level project execution.</p>
          </div>
        </div>
        
        <div class="feature-icons-grid">
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-cubes"></i></div>
            <span>Blocks & GPs</span>
          </div>
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-bridge"></i></div>
            <span>Project Execution</span>
          </div>
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-clock-rotate-left"></i></div>
            <span>Progress Updates</span>
          </div>
          <div class="f-item">
            <div class="f-icon"><i class="fa-solid fa-camera"></i></div>
            <span>Photos & Reports</span>
          </div>
        </div>

        <button class="card-action-btn">
          Update Field Progress <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </section>

    <!-- 6. ATTENTION ALERT SECTION -->
    <section class="attention-banner">
      <div class="banner-left">
        <div class="bell-icon-wrap">
          <i class="fa-solid fa-bell"></i>
        </div>
        <div class="banner-text">
          <h4>Projects Requiring Immediate Attention</h4>
          <p>View <strong>{{ criticalProjects().length }}</strong> critical project(s) — Stuck, Recurring Intervention, or Overdue &gt; 60 days.</p>
        </div>
      </div>
      <button class="view-now-btn" (click)="showCriticalModal.set(true)">View Now <i class="fa-solid fa-arrow-right"></i></button>
    </section>

    <!-- MOBILE SECTION LABEL: Project Summary -->
    <h3 class="mob-section-label">Project Summary</h3>

    <!-- 7. BOTTOM STATISTICS BAR -->
    <section class="stats-bar-container" aria-label="Field execution summary">
      <a class="stat-box is-link" (click)="openFeList('feAll')">
        <div class="stat-icon-circle bg-blue-soft"><i class="fa-solid fa-layer-group"></i></div>
        <div class="stat-data">
          <span class="stat-val">{{ feStats$.totalProjects() }}</span>
          <span class="stat-lbl">Total Projects <br><small class="lbl-desktop">Field Execution</small><small class="lbl-mobile">All Departments</small></span>
        </div>
      </a>
      <a class="stat-box is-link" (click)="openFeList('feSanctioned')">
        <div class="stat-icon-circle bg-green-soft"><i class="fa-solid fa-indian-rupee-sign"></i></div>
        <div class="stat-data">
          <span class="stat-val stat-val-desktop">₹{{ feStats$.sanctionedAmount() | number }}L</span>
          <span class="stat-val stat-val-mobile">{{ formatFeSanctioned() }}</span>
          <span class="stat-lbl">Total Sanctioned <br><small class="lbl-desktop">Execution Projects</small><small class="lbl-mobile">All Projects</small></span>
        </div>
      </a>
      <a class="stat-box is-link" (click)="openFeList('feProgress')">
        <div class="stat-icon-circle bg-purple-soft"><i class="fa-solid fa-chart-pie"></i></div>
        <div class="stat-data">
          <span class="stat-val">{{ feStats$.avgProgress() }}%</span>
          <span class="stat-lbl">Avg. Progress <br><small class="lbl-desktop">Physical Progress</small><small class="lbl-mobile">Overall</small></span>
        </div>
      </a>
      <a class="stat-box is-link" (click)="openFeList('feDelayed')">
        <div class="stat-icon-circle bg-orange-soft"><i class="fa-solid fa-clock"></i></div>
        <div class="stat-data">
          <span class="stat-val">{{ feStats$.delayedCount() }}</span>
          <span class="stat-lbl">Projects Delayed <br><small class="lbl-desktop">Execution Tracking</small><small class="lbl-mobile">&gt; 60 Days</small></span>
        </div>
      </a>
      <a class="stat-box is-link" (click)="openFeList('feCompleted')">
        <div class="stat-icon-circle bg-teal-soft"><i class="fa-solid fa-check-double"></i></div>
        <div class="stat-data">
          <span class="stat-val">{{ feStats$.completedCount() }}</span>
          <span class="stat-lbl">Completed Projects <br><small>Execution Completed</small></span>
        </div>
      </a>
      <div class="stat-box stat-box-updated">
        <div class="stat-icon-circle bg-blue-soft"><i class="fa-regular fa-calendar-check"></i></div>
        <div class="stat-data">
          <span class="stat-lbl-top">UPDATED ON</span>
          <span class="stat-val stat-val-blue">Today, {{ feStats$.lastSync() | date:'h:mm a' }}</span>
          <span class="stat-lbl"><small>Field Execution Data</small></span>
        </div>
      </div>
    </section>
  </main>

  <!-- DYNAMIC PROJECT LIST MODAL -->
  @if (listFilter()) {
  <div class="logout-modal-overlay" (click)="closeList()">
    <div class="critical-modal-card" (click)="$event.stopPropagation()">
      <div class="critical-modal-header">
        <div class="critical-modal-title-wrap">
          <div class="bell-icon-wrap">
            <i class="fa-solid fa-list-check"></i>
          </div>
          <div>
            <h3 class="critical-modal-title">{{ listTitle() }}</h3>
            <p class="critical-modal-subtitle">{{ listProjects().length }} project(s)</p>
          </div>
        </div>
        <button class="critical-modal-close" (click)="closeList()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="critical-modal-body">
        @if (listProjects().length === 0) {
          <div class="critical-empty">
            <i class="fa-solid fa-circle-check"></i>
            <p>No projects to show.</p>
          </div>
        } @else {
          <table class="critical-table">
            <thead>
              <tr>
                <th>Project</th>
                <th>{{ listIsFieldExecution() ? 'Block / GP' : 'Department' }}</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Cost (₹L)</th>
              </tr>
            </thead>
            <tbody>
              @for (proj of listProjects(); track proj.id) {
                <tr (click)="openProject(proj.id)" class="critical-table-row-link" title="View project details">
                  <td>
                    <button type="button" class="critical-proj-name-btn">{{ proj.name }}</button>
                  </td>
                  <td>{{ listIsFieldExecution() ? fieldExecutionLocation(proj) : departmentDisplayName(proj) }}</td>
                  <td><span class="status-pill" [class.stuck]="proj.status === 'Stuck'" [class.completed]="proj.status === 'Completed'">{{ proj.status }}</span></td>
                  <td>{{ proj.physical || proj.progress || 0 }}%</td>
                  <td>{{ proj.cost | number }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>

      <div class="critical-modal-footer">
        <button class="btn-cancel" (click)="closeList()">Close</button>
      </div>
    </div>
  </div>
  }

  <!-- CRITICAL PROJECTS MODAL -->
  @if (showCriticalModal()) {
  <div class="logout-modal-overlay" (click)="showCriticalModal.set(false)">
    <div class="critical-modal-card" (click)="$event.stopPropagation()">
      <div class="critical-modal-header">
        <div class="critical-modal-title-wrap">
          <div class="bell-icon-wrap">
            <i class="fa-solid fa-bell"></i>
          </div>
          <div>
            <h3 class="critical-modal-title">Projects Requiring Immediate Attention</h3>
            <p class="critical-modal-subtitle">{{ criticalProjects().length }} critical project(s) need your intervention</p>
          </div>
        </div>
        <button class="critical-modal-close" (click)="showCriticalModal.set(false)">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="critical-modal-body">
        @if (criticalProjects().length === 0) {
          <div class="critical-empty">
            <i class="fa-solid fa-circle-check"></i>
            <p>No critical projects at the moment.</p>
          </div>
        } @else {
          <table class="critical-table">
            <thead>
              <tr>
                <th>Project</th>
                <th>Department</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Cost (₹L)</th>
              </tr>
            </thead>
            <tbody>
              @for (proj of criticalProjects(); track proj.id) {
                <tr (click)="openProject(proj.id)" class="critical-table-row-link" title="View project details">
                  <td>
                    <button type="button" class="critical-proj-name-btn">{{ proj.name }}</button>
                  </td>
                  <td>{{ departmentDisplayName(proj) }}</td>
                  <td>
                    @if (proj.recurringIntervention) {
                      <span class="reason-chip recurring"><i class="fa-solid fa-rotate"></i> Recurring</span>
                    }
                    @if (proj.status === 'Stuck') {
                      <span class="reason-chip stuck"><i class="fa-solid fa-circle-exclamation"></i> Stuck</span>
                    }
                    @if ((proj.targetDate || proj.end) && proj.status !== 'Completed') {
                      @if (criticalReason(proj).includes('Overdue')) {
                        <span class="reason-chip overdue"><i class="fa-regular fa-clock"></i> Overdue</span>
                      }
                    }
                  </td>
                  <td><span class="status-pill" [class.stuck]="proj.status==='Stuck'" [class.completed]="proj.status==='Completed'" [class.inprogress]="proj.status==='In Progress'">{{ proj.status }}</span></td>
                  <td>{{ proj.physical || 0 }}%</td>
                  <td>{{ proj.cost | number }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>

      <div class="critical-modal-footer">
        <button class="btn-cancel" (click)="showCriticalModal.set(false)">Close</button>
      </div>
    </div>
  </div>
  }

  <!-- LOGOUT CONFIRMATION MODAL -->
  @if (showLogoutModal()) {
  <div class="logout-modal-overlay" (click)="showLogoutModal.set(false)">
    <div class="logout-modal-card" (click)="$event.stopPropagation()">
      <div class="logout-modal-icon">
        <i class="fa-solid fa-right-from-bracket"></i>
      </div>
      <h3 class="logout-modal-title">Confirm Logout</h3>
      <p class="logout-modal-msg">Are you sure you want to exit the Dhamnagar D3 system?</p>
      <div class="logout-modal-actions">
        <button class="btn-cancel" (click)="showLogoutModal.set(false)">Cancel</button>
        <button class="btn-confirm" (click)="logout()">Yes, Logout</button>
      </div>
    </div>
  </div>
  }

  <!-- 8. FOOTER NOTICE -->
  <footer class="footer-minimal">
    <i class="fa-solid fa-shield-halved"></i>
    <span>This is a secure government system. All activities are monitored and recorded.</span>
  </footer>
</div>
